module.exports = __webpack_public_path__ + "static/media/ecommerce.fb98fae5.jpg";